import { styled } from '@mui/material';
import { Popup, PopupProps } from 'react-map-gl';
import { flexCenter } from '../commonUI/cssClasses';

interface StyledPopupProps extends PopupProps {
  padding?: string;
}

const StyledPopup = styled(({ className, ...props }: StyledPopupProps) => (
  <Popup
    className={className}
    {...props}
    style={{
      minWidth: 'fit-content',
    }}
  />
))(({ theme, padding = '1rem' }) => ({
  '& .mapboxgl-popup-content': {
    ...flexCenter,
    padding: padding,
    borderRadius: theme.borderRadius.primary,
    background: 'rgba(32, 34, 38, 0.90)',
    '& .MuiTypography-root': {
      width: '100%',
      color: theme.colors.common.white,
      fontSize: '1rem',
      whiteSpace: 'nowrap',
    },
    '& .MuiTableCell-root': {
      border: '0',
      padding: '0 2rem 0 0',
      '&:last-child': {
        padding: '0',
      },
    },
  },
  '& .mapboxgl-popup-tip': {
    filter: 'brightness(0.15)',
  },
}));

export default StyledPopup;
